import { LocationStrategy } from '@angular/common';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { NgxLocalizedNumbersService } from 'ngx-localized-numbers/localized-numbers.service';
import { LoggedInUser, SessionData } from './models/loggedinuser.model';
import { AuthService } from './services/user/auth.service';

@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.css'
  ]
})
export class AppComponent implements OnInit {
  @HostBinding('class') public cssClass = 'main-body';
  storageType: string = '';

  constructor(
    private localStorageService: LocalStorageService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private localizedNumbersService: NgxLocalizedNumbersService,
    private location: LocationStrategy
  ) {

    // blocco goBackButton del browser
    this.location.onPopState(() => {
      document.body.style.overflow = 'auto';
      if (this.router.url === '/new-campaign/4') {
        window.history.forward();
      }
    });

    this.authService.checkLoginData();
    // this language will be used as a fallback when a translation isn't found in the current language
    // this.translate.setDefaultLang('en'); ANTONIO QUI VENIVA CARICATO PRIMA L'INGLESE CHIAMATA A VUOTO INUTILE
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    console.log('browser language: ' + translate.getBrowserLang());
    this.authService.sessionHelper = new SessionData();

    if(this.localStorageService.get('userData')){
      let user: LoggedInUser = this.localStorageService.get('userData');
      this.authService.sessionHelper.selectedLanguage = user.language;
      this.translate.use(user.language);
    }
    else if(sessionStorage.getItem('userData')){
      let user: LoggedInUser = JSON.parse(sessionStorage.getItem('userData'));
      this.authService.sessionHelper.selectedLanguage = user.language;
      this.translate.use(user.language);
    }
    else{
      // ANTONIO QUI E' DOVE VIENE SCELTA LA LINGUA
      if (['it', 'en'].indexOf(translate.getBrowserLang()) != -1) {
        this.translate.use(translate.getBrowserLang());
        this.authService.sessionHelper.selectedLanguage = translate.getBrowserLang();
      } else {
        this.translate.use('en');
        this.authService.sessionHelper.selectedLanguage = 'en';
      }

    }

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if(this.localStorageService.get('userData')){
        let user: LoggedInUser = this.localStorageService.get('userData');
        user.language = event.lang;
        this.localStorageService.set('userData',user);
      }
      else if(sessionStorage.getItem('userData')){
        let user: LoggedInUser = JSON.parse(sessionStorage.getItem('userData'));
        user.language = event.lang;
        sessionStorage.setItem('userData',JSON.stringify(user));
      }

      // ANTONIO AGGIUNTO PER EVITARE CHIAMATA LANGUAGE
      if(this.translate.currentLang!==event.lang)
        this.translate.reloadLang(event.lang);

    });
  }

  ngOnInit() {
    console.log('App on init...');
    if (this.authService.user!= null && 
        this.authService.user != undefined &&
          new Date(this.authService.user.tokenExpireDate) < new Date) {
      this.authService.logout();
    }

    if (['it'].indexOf(this.translate.currentLang) !== -1) {
      console.log('LOCALE NUMBER SET TO it_IT, CURRENT LANG:', this.translate.currentLang);
      this.localizedNumbersService.setLocale('it_IT');
    } else {
      console.log('LOCALE NUMBER SET TO en_US, CURRENT LANG:', this.translate.currentLang);
      this.localizedNumbersService.setLocale('en_US');
    }


    //tempo di check per la scadenza del token (in secondi)
    let checkTimeSeconds = 60 * 5;
    //checkTimeSeconds = 60; //per prova

    var self = this;

    /*
    setTimeout(function(){
      self.authService.checkTokenInterval()
    },5000);
    */

    /*
   TimerObservable.create(0, checkTimeSeconds * 1000)
   .takeWhile(() => true)
   .subscribe(() => {
        this.authService.checkTokenInterval();
   });
   */

    setInterval(() => {
      self.authService.checkTokenInterval();
    }, 1000 * checkTimeSeconds);

    console.log('App on init - end');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts